import React, { Component } from 'react';
import { createPortal } from 'react-dom';

import './tab-with-content.scss';

import { TabWithContentAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { array, arrayOf, bool, element, eventListener, expression, func, instanceOf, number, object, oneOf, oneOfType, shape, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, getLostProps, isFunction, propagateProps } from '@philips-emr/tws-utils';

const acceptedTypes = [
  ComponentType.AGGREGATOR,
  ComponentType.BEHAVIOR,
  ComponentType.DATA_DISPLAY,
  ComponentType.FORM,
  ComponentType.LAYOUT,
  ComponentType.LIST,
];

@AwesomeComponent({ type: ComponentType.NAVIGATION, api: TabWithContentAPI })
class TabWithContent extends Component {
  static propTypes = {
    activeTab: string,
    badge: oneOfType([number, string]),
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    count: oneOfType([number, string]),
    data: oneOf([array, object]),
    label: expression,
    name: string,
    onClick: eventListener,
    onContextMenu: eventListener,
    onDoubleClick: eventListener,
    tabContentRef: oneOfType([
      func,
      shape({ current: instanceOf(Element) }),
    ]).notEnumerable(),
    uppercase: bool,
    uuid: string,
  };

  static defaultProps = {
    uppercase: true,
  };

  onClick = () => {
    const { name, onClick } = this.props;

    isFunction(onClick) && onClick({ value: name });
  };

  onDoubleClick = () => {
    const { name, onDoubleClick } = this.props;

    isFunction(onDoubleClick) && onDoubleClick({ value: name });
  };

  onContextMenuClick = () => {
    const { name, onContextMenu } = this.props;

    isFunction(onContextMenu) && onContextMenu({ value: name });
  };

  isActive() {
    const { activeTab, name } = this.props;

    return name ? activeTab === name : false;
  }

  getClassName() {
    const { uppercase } = this.props;

    return classNames({
      'c-tab-with-content': true,
      'c-tab-with-content--uppercase': uppercase,
      'is-active': this.isActive(),
    });
  }

  renderTab() {
    const { badge, count, label } = this.props;

    return (
      <div className="c-tab-with-content__tab"
        onClick={this.onClick}
        onDoubleClick={this.onDoubleClick}
        onContextMenu={this.onContextMenuClick}
      >
        <span className="c-tab-with-content__text">{msg(label)}</span>
        <span className="c-tab-with-content__badge">{count || badge}</span>
      </div>
    );
  }

  renderContent() {
    const { children, tabContentRef, uuid } = this.props;

    if (!this.isActive()) {
      return null;
    }

    if (!tabContentRef) {
      return null;
    }

    const Container = ContainerProvider.provide(this);

    const content = (
      <Container acceptedTypes={acceptedTypes} uuid={uuid}>
        {propagateProps(children, getLostProps(TabWithContent.propTypes, this.props))}
      </Container>
    );

    return createPortal(content, tabContentRef);
  }

  render() {
    return (
      <div className={this.getClassName()}>
        {this.renderTab()}
        {this.renderContent()}
      </div>
    );
  }
}

export default TabWithContent;
